export const quizFactory = () => {
  return {
    id: null,
    source_type: 'Quiz',
    number_of_questions: 0,
    video_reference: '',
    quiz_title: '',
    slug: '',
    time_cap_in_seconds: 0,
    min_score: '0.70',
    max_attempts_per_user: null,
    company: null,
    modified: null,
    created: null,
    shuffle_questions: true,
    duration_in_seconds: 0
  }
}
export const questionFactory = () => {
  return {
    id: null,
    content_md: '',
    answers: [],
    shuffle_answers: true
  }
}

export const answerFactory = () => {
  return {
    id: null,
    content_md: '',
    is_correct: false,
    stick_to_bottom: false
  }
}

// We do not use Attempts in Admin.
// export const attemptFactory = () => {
//   return {
//     id: null,
//     user: null,
//     start_datetime: null,
//     end_datetime: null,
//     last_updated_datetime: '',
//     remaining_time_in_seconds: 1800,
//     time_cap_in_seconds: 1800,
//     status: '',
//     score: 0.0,
//     questions: {
//       version: 1,
//       questions: [],
//     },
//     source: {
//       id: null,
//       source_type: 'Quiz',
//       number_of_questions: 0,
//       metadata: {},
//     },
//   }
// }